// Receipt Configuration Editor Module
export function initializeReceiptConfig() {
    const drawer = document.getElementById('receipt-config-drawer');
    const openBtn = document.getElementById('open-receipt-config');
    const closeBtn = document.getElementById('close-receipt-config');
    const contentWrapper = document.getElementById('receipt-content-wrapper');

    if (!drawer || !openBtn || !closeBtn) {
        return;
    }

    function openDrawer() {
        drawer.classList.add('open');
        if (contentWrapper) {
            const drawerWidth = drawer.getBoundingClientRect().width || 420;
            contentWrapper.style.transform = `translateX(-${drawerWidth}px)`;
        }
        initializeReceiptConfigEditor();

        // Focus role if specified
        try {
            const openRole = drawer.dataset.focusRole || '';
            if (openRole) {
                setTimeout(() => {
                    const root = document.getElementById('receipt-config-root');
                    const target = root && root.querySelector(`[data-role="${openRole}"]`);
                    if (target) {
                        target.classList.add('highlight-role');
                        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
                        setTimeout(() => { target.classList.remove('highlight-role'); }, 2000);
                    }
                }, 50);
            }
        } catch (e) {
        }
    }

    function closeDrawer() {
        drawer.classList.remove('open');
        if (contentWrapper) {
            contentWrapper.style.transform = '';
        }
    }

    openBtn.addEventListener('click', (e) => {
        e.preventDefault();
        openDrawer();
    });

    closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        closeDrawer();
    });

    function initializeReceiptConfigEditor() {
        const root = document.getElementById('receipt-config-root');
        if (!root || root.dataset.initialized === 'true') {
            return;
        }

        let config = [];
        let roles = [];
        let sources = [];

        try {
            config = JSON.parse(root.dataset.receiptConfig || '[]');
            roles = JSON.parse(root.dataset.roles || '[]');
            sources = JSON.parse(root.dataset.sources || '[]');
        } catch (e) {
            showToast('Error loading configuration data', false);
            return;
        }

        const selectedRole = root.dataset.selectedRole || '';
        if (selectedRole) {
            roles = roles.filter(r => r.key === selectedRole);
        }

        const saveUrl = root.dataset.saveUrl;
        const regenerateUrl = root.dataset.regenerateUrl;

        if (!saveUrl || !regenerateUrl) {
            return;
        }

        function showToast(message, isSuccess) {
            const toast = document.createElement('div');
            toast.className = 'success-toast';
            toast.style.cssText = `
        position: fixed;
        top: 20px;
        right: 20px;
        padding: 12px 20px;
        border-radius: 6px;
        color: #fff;
        z-index: 2000;
        background: ${isSuccess ? 'var(--rb-success, #28a745)' : 'var(--rb-danger, #dc3545)'};
      `;
            toast.textContent = message;
            document.body.appendChild(toast);
            setTimeout(() => {
                if (document.body.contains(toast)) {
                    document.body.removeChild(toast);
                }
            }, 2500);
        }

        function getCSRFToken() {
            const tokenElement = document.querySelector('meta[name="csrf-token"]');
            if (!tokenElement) {
                return '';
            }
            return tokenElement.content;
        }

        function normalizeConfigForSave(rawConfig) {
            const errors = [];
            const normalized = (rawConfig || []).map((field, idx) => {
                const role = (field.role || '').toString().trim();
                const source = (field.source || '').toString().trim();
                const label = (field.label || '').toString().trim();
                const key = (field.key || `field_${idx}_${Date.now()}`).toString();

                if (!role) {
                    errors.push(`Field ${idx + 1} is missing a role`);
                }
                if (!source) {
                    const name = label || `field ${idx + 1}`;
                    errors.push(`Select a source for ${name}`);
                }

                return { role, key, label, source };
            });

            return { normalized, errors };
        }

        function renderEditor() {
            root.innerHTML = '';
            const grouped = roles.reduce((acc, r) => {
                acc[r.key] = [];
                return acc;
            }, {});

            config.forEach(f => {
                grouped[f.role] = grouped[f.role] || [];
                grouped[f.role].push(f);
            });

            roles.forEach(role => {
                const wrapper = document.createElement('div');
                wrapper.className = 'mb-4 role-section';
                wrapper.dataset.role = role.key;

                const header = document.createElement('h6');
                header.className = 'mb-2';
                header.innerHTML = `<strong>${role.label}</strong> Receipt Fields`;
                wrapper.appendChild(header);

                const list = document.createElement('div');
                list.className = 'sortable-list';
                list.dataset.role = role.key;

                const fields = grouped[role.key] || [];
                fields.forEach((field, idx) => {
                    const item = document.createElement('div');
                    item.className = 'field-item mb-2 p-2 border rounded d-flex align-items-center';
                    item.dataset.idx = idx;
                    item.dataset.role = role.key;
                    item.style.cursor = 'move';
                    item.style.backgroundColor = 'var(--rb-surface-alt, #f8f9fa)';

                    const handle = document.createElement('i');
                    handle.className = 'fa fa-bars mr-2';
                    handle.style.cursor = 'grab';

                    const labelInput = document.createElement('input');
                    labelInput.type = 'text';
                    labelInput.className = 'form-control form-control-sm mr-2';
                    labelInput.value = field.label || '';
                    labelInput.placeholder = 'Field Label';
                    labelInput.style.flex = '1';
                    labelInput.addEventListener('change', () => {
                        field.label = labelInput.value;
                    });

                    const sourceSelect = document.createElement('select');
                    sourceSelect.className = 'form-control form-control-sm mr-2';
                    sourceSelect.style.flex = '2';

                    const emptyOpt = document.createElement('option');
                    emptyOpt.value = '';
                    emptyOpt.textContent = '-- Select Source --';
                    sourceSelect.appendChild(emptyOpt);

                    sources.forEach(src => {
                        const opt = document.createElement('option');
                        opt.value = src.value;
                        opt.textContent = src.label;
                        if (field.source === src.value) opt.selected = true;
                        sourceSelect.appendChild(opt);
                    });

                    sourceSelect.addEventListener('change', () => {
                        field.source = sourceSelect.value;
                    });

                    const removeBtn = document.createElement('button');
                    removeBtn.className = 'btn btn-sm btn-danger';
                    removeBtn.innerHTML = '<i class="fa fa-trash"></i>';
                    removeBtn.addEventListener('click', () => {
                        config = config.filter(f => f !== field);
                        renderEditor();
                    });

                    item.appendChild(handle);
                    item.appendChild(labelInput);
                    item.appendChild(sourceSelect);
                    item.appendChild(removeBtn);
                    list.appendChild(item);
                });

                if (typeof Sortable !== 'undefined') {
                    new Sortable(list, {
                        animation: 150,
                        handle: '.fa-bars',
                        onEnd: function (evt) {
                            const roleFields = config.filter(f => f.role === role.key);
                            const [movedField] = roleFields.splice(evt.oldIndex, 1);
                            roleFields.splice(evt.newIndex, 0, movedField);

                            config = config.filter(f => f.role !== role.key).concat(roleFields);
                        }
                    });
                } else {
                }

                const addBtn = document.createElement('button');
                addBtn.className = 'btn btn-sm btn-outline-primary mt-2';
                addBtn.innerHTML = '<i class="fa fa-plus mr-1"></i>Add Field';
                addBtn.addEventListener('click', () => {
                    const newField = {
                        role: role.key,
                        key: 'custom_' + Math.random().toString(36).slice(2),
                        label: 'New Field',
                        source: ''
                    };

                    const roleIndex = config.findIndex(f => f.role === role.key);
                    if (roleIndex === -1) {
                        config.push(newField);
                    } else {
                        const lastRoleIndex = config.map((f, i) => f.role === role.key ? i : -1)
                            .filter(i => i !== -1).pop();
                        config.splice(lastRoleIndex + 1, 0, newField);
                    }

                    renderEditor();
                });

                wrapper.appendChild(list);
                wrapper.appendChild(addBtn);
                root.appendChild(wrapper);
            });

            setupSaveButtons();
        }

        function setupSaveButtons() {
            const saveBtn = document.getElementById('receipt-config-save');
            const regenBtn = document.getElementById('receipt-config-regenerate');

            if (saveBtn && !saveBtn.hasAttribute('data-initialized')) {
                saveBtn.setAttribute('data-initialized', 'true');
                saveBtn.onclick = async function () {
                    const originalText = saveBtn.innerHTML;
                    saveBtn.innerHTML = '<i class="fa fa-spinner fa-spin mr-1"></i>Saving...';
                    saveBtn.disabled = true;

                    const validation = normalizeConfigForSave(config);
                    if (validation.errors.length > 0) {
                        showToast(validation.errors[0], false);
                        saveBtn.innerHTML = originalText;
                        saveBtn.disabled = false;
                        return;
                    }
                    config = validation.normalized;

                    try {
                        const response = await fetch(saveUrl, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'X-CSRF-Token': getCSRFToken(),
                                'Accept': 'application/json'
                            },
                            credentials: 'same-origin',
                            body: JSON.stringify({ receipt_fields_config: config })
                        });

                        if (!response.ok) {
                            const text = await response.text();
                            throw new Error(`Save failed: ${response.status}`);
                        }

                        const data = await response.json();
                        showToast('Configuration saved successfully!', true);
                        setTimeout(() => { location.reload(); }, 1200);
                    } catch (error) {
                        showToast(`Failed to save: ${error.message}`, false);
                        saveBtn.innerHTML = originalText;
                        saveBtn.disabled = false;
                    }
                };
            }

            if (regenBtn && !regenBtn.hasAttribute('data-initialized')) {
                regenBtn.setAttribute('data-initialized', 'true');
                regenBtn.onclick = async function () {
                    if (!confirm('This will reset all fields to default values. Continue?')) return;

                    const originalText = regenBtn.innerHTML;
                    regenBtn.innerHTML = '<i class="fa fa-spinner fa-spin mr-1"></i>Regenerating...';
                    regenBtn.disabled = true;

                    try {
                        const response = await fetch(regenerateUrl, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'X-CSRF-Token': getCSRFToken(),
                                'Accept': 'application/json'
                            },
                            credentials: 'same-origin'
                        });

                        if (!response.ok) {
                            const text = await response.text();
                            throw new Error(`Regeneration failed: ${response.status}`);
                        }

                        const data = await response.json();

                        if (data && data.receipt_fields_config) {
                            config = data.receipt_fields_config;
                            renderEditor();
                            showToast('Fields reset to defaults!', true);
                        }

                        regenBtn.innerHTML = originalText;
                        regenBtn.disabled = false;
                    } catch (error) {
                        showToast(`Failed to regenerate: ${error.message}`, false);
                        regenBtn.innerHTML = originalText;
                        regenBtn.disabled = false;
                    }
                };
            }
        }

        root.dataset.initialized = 'true';
        renderEditor();
    }
}
